import { useSession } from "../components/SessionProvider";
export const useDownloadWithToken = () => {
    const apiUrl = import.meta.env.VITE_API_URL_MAIN;

    const { userLogin } = useSession();
    const downloadWithToken = async (command, params = {}, filename = `export_${Date.now()}.xlsx`) => {
        const urlParams = new URLSearchParams({ command, ...params });
        const url = `${apiUrl}${urlParams.toString()}`;
        const response = await fetch(url, {
            method: 'GET',
            credentials: "include",
            headers: {
                'X-API-TOKEN': userLogin.session_token,   // ← the token you want
                'X-API-EMAIL': userLogin.user_email ?? '',
            },
        });

        if (!response.ok) {
            throw new Error(`Download failed: ${response.status}`);
        }

        const blob = await response.blob();
        const blobUrl = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = blobUrl;
        link.setAttribute('download', filename);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(blobUrl);
    };
    return { downloadWithToken };
};
